import * as React from "react";
import PropTypes from 'prop-types';
import {Icon, Menu} from "semantic-ui-react";
import {connect} from "react-redux";
import {createStructuredSelector} from "reselect";
import {makeRedirectUrl} from "../../redux/global/redirect/selector";
import {push} from 'connected-react-router/immutable'
import {compose} from "redux";
import {changeRedirectState} from "../../redux/global/redirect/actions";
import {FormattedMessage} from "react-intl";
import messages from "./messages";

export class NavBarMenu extends React.PureComponent {
    state = {
        active: ''
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {active} = this.state;

        const menuItem = this.props.menuList.map(data => {
            const content = data.translate ? <FormattedMessage {...messages[data.content]}/> : data.content;
            return <Menu.Item key={data.key}
                              active={active === data.key}
                              onClick={() => this.props.handleItemClick(data.href, data.redirect)}>
                {content}
            </Menu.Item>
        });
        return (
            <React.Fragment>
                {menuItem}
            </React.Fragment>
        )
    }

}

NavBarMenu.propTypes = {
    menuList: PropTypes.array.isRequired,
    handleItemClick: PropTypes.func
};

export function mapDispatchToProps(dispatch) {
    return {
        handleItemClick: (href, redirect) => {
            if (redirect) {
                dispatch(changeRedirectState(redirect))
            }
            dispatch(push(href));
            window.scrollTo(0,0);
        }
    };
}

const mapStateToProps = createStructuredSelector({
    redirectState: makeRedirectUrl()
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(NavBarMenu);


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarMenu.js